// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"36":"f2c19835","186":"6ad40152","431":"c8facdac","782":"4a70bc00"}[chunkId] + ".css";
};